module.exports = __webpack_public_path__ + "static/media/grey-checkbox.042ad9e5.svg";